import { useEffect, useMemo, useState } from 'react'

import cls from '../../util/cls'
import { camelToNormal } from '../../util/util'
import { Checkbox } from "@mui/material"

import styles from './generic.module.css'
import NoContent from '../forms/no-content'

const initSelectedState = (data, init = true) => {
    const allChecked = data?.reduce((a, c) => {
        a[c?._id] = init
        return a
    }, {})
    allChecked["_header"] = init

    return allChecked
}

const TableItem = ({ k, x }) => {
    if (typeof x[k] === 'function') {
        return x[k]()
    }

    return k === "name" ? <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        {x?.hasOwnProperty('_icon') ?  x?._icon() : null}
        {x[k]}
    </div> : x[k]
}

const TableHeaderItem = ({ x, shouldHide, index }) => {    
    if (shouldHide) {
        return <th key={index} style={{ textAlign: 'left', padding: '0px 12px' }}>
        {}
    </th>
    }

    return <th key={index} style={{ textAlign: 'left', padding: '0px 12px' }}>
        {camelToNormal(x)}
    </th>
}

const RequestTableBody = ({
    data = [],
    onClick,
    activeId,
    setChecked = () => { },
    hiddenHeaderKeys = []
}) => {
    const [selected, setSelected] = useState(initSelectedState(data, false))
    const headers = useMemo(() => Object.keys(data[0]).filter(x => !x.includes("_")), [data])

    useEffect(() => {
        setChecked(Object.keys(selected).filter(x => selected[x] === true && x !== "_header"))
    }, [selected])

    useEffect(() => {
        setSelected(initSelectedState(data, false))
    }, [data])

    const onCheckboxClick = (e, id) => {
        e.stopPropagation()

        setSelected((prev) => ({
            ...prev,
            [id]: !prev[id],
        }))
    }

    const onHeaderCheckboxClick = (e) => {
        e.preventDefault()

        setSelected((prev) => initSelectedState(data, !prev['_header']))
    }
    return (
        <div style={{ maxHeight: '100%', overflowY: 'auto' }}>
            <table className={styles.table}>
                <thead>
                    <tr className={styles.tableHeader}>
                        <th style={{ textAlign: 'left', padding: '12px' }}>
                            <Checkbox checked={selected['_header']} onClick={onHeaderCheckboxClick} />
                        </th>
                        {headers.map((x, idx) => (
                            <TableHeaderItem shouldHide={hiddenHeaderKeys.includes(x)} x={x} item={data[0][x]} index={idx} />
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data
                        .sort((a, b) => new Date(b?.createdAt) - new Date(a?.createdAt))
                        .map((x) => (
                            <tr
                                onClick={() => onClick(x)}
                                className={cls(styles.tableCell, activeId === x?._id && styles.tableCellActive)}
                                key={x?._id}
                            >
                                <td style={{ textAlign: 'left', padding: '12px' }}>
                                    <Checkbox checked={selected[x?._id]} onClick={(e) => onCheckboxClick(e, x?._id)} />
                                </td>
                                {Object.keys(x)
                                    .filter(key => !key.includes("_"))
                                    .map((key, index) => (
                                        <td key={index} style={{ textAlign: 'left', padding: '12px' }}>
                                            <TableItem x={x} k={key} />
                                        </td>
                                    ))}
                            </tr>
                        ))}
                </tbody>
            </table>

        </div>
    )
}

const RequestTable = ({
    data = [],
    onClick = () => {},
    activeId,
    setChecked = () => { },
    hiddenHeaderKeys=[],
}) => {
    if (data?.length === 0) {
        return <div style={{ margin: 20 }}><NoContent /></div>
    }

    return <RequestTableBody hiddenHeaderKeys={hiddenHeaderKeys} data={data} onClick={onClick} activeId={activeId} setChecked={setChecked} />
}

export default RequestTable